import { getChatUsersApiCall } from '@/entities/ChatUser/ChatUserService'
import { isFetchCollectionResultSuccessful } from '@/entities/FetchResult'
import { trans } from '@/helpers/trans'
import { setChatUsers, setError, setIsLoading } from '@/redux/chatUsers/chatUsersReducer'
import { TypedDispatch } from '@/redux/store'
import { setToast } from '@/redux/toasts/toastsReducer'
import { ToastType } from '@/types'

export const fetchChatUsers = () => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setError(''))

    try {
        const response = await getChatUsersApiCall()

        if (! isFetchCollectionResultSuccessful(response)) {
            dispatch(setError(response.error))
            dispatch(setToast({ text: trans('pages.messages.loadColleaguesFailed'), type: ToastType.fail }))

            return
        }

        dispatch(setChatUsers(response.data))
    } catch (error) {
        console.error('[fetchChatUsers]', error)
    } finally {
        dispatch(setIsLoading(false))
    }
}
